import { useMemo, useState } from 'react';
import { Box, Text, Flex, Image } from '@chakra-ui/react';

import notifyError from 'assets/svg/notify-error.svg';

import Card from 'components/Card/Card';

export default function Errors (props) {
  return (
    <>
    	<Card 
          bg="rgba(200, 23, 13, 0.30)"
          borderRadius="16px"
          maxW={props.maxW ?? '100%'}
          variant="ghost" 
          padding='24px 16px' 
          mb={{ sm: '8px' }}>
          <Flex>
            <Image src={notifyError} h="24px"/>
            <Text ml="16px" maxW={{sm: '100%', md: '70%'}} mt="2px" variant="text-md">
			  {typeof props.error === 'string' ? `Error: ${props.error}` : 'An unknown error occurred, try changing the fields or refreshing the page'}
            </Text>
          </Flex>
        </Card>
    </>
  );
}